import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { GiCrossedBones } from 'react-icons/gi';
import { LuSave } from 'react-icons/lu';
import { FaMotorcycle, FaCarSide, FaTruckPickup } from "react-icons/fa6";

const AddVehicleMaster = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);


  const validationSchema = Yup.object({
    commercialVehicle: Yup.string().required("Commercial Vehicle selection is required"),
    make: Yup.string().required("Make is required"),
    model: Yup.string().required("Model is required"),
    cc: Yup.string().required("CC is required"),
    seatingCapacity: Yup.string().required("Seating Capacity is required"),
    fuelType: Yup.string().required("Fuel Type is required"),
    grossWeight: Yup.string().required("Gross Weight is required"),
    exShowroomPrice: Yup.string().required("Ex Showroom Price is required"),
  });


  const handleSubmit = (values, { resetForm }) => {
    console.log("Form Submitted", values);
    alert("Form submitted!");
    resetForm();
  };

  return (
    <div className="formContainer lg:p-4 rounded" style={{ boxShadow: "0 0 8px #ccc" }}>
      <div className="flex flex-col lg:mx-5 p-4 border rounded bg-white" style={{ boxShadow: "0px 0px 12px #cac8c8" }}>

        <h5 className="text-brandRed font-bold border-b border-brandRed pb-2 mb-4 px-2">
          Vehicle Master
        </h5>

        {/* Vehicle Type Icons */}
        <div className="d-flex gap-4 mb-4 justify-content-start">
          <div
            className={`text-center p-2 border-2 rounded-circle ${selectedVehicle === "bike" ? "bg-brandRed border-3 border-brandRed" : "border-brandRed"}`}
            style={{ cursor: "pointer" }}
            onClick={() => setSelectedVehicle("bike")}
            title="Two Wheeler"
          >
            <FaMotorcycle size={48} className={selectedVehicle === "bike" ? "text-white" : "text-brandRed"} />
          </div>
          <div
            className={`text-center p-2 border-2 rounded-circle ${selectedVehicle === "car" ? "bg-brandRed border-3 border-brandRed" : "border-brandRed"}`}
            style={{ cursor: "pointer" }}
            onClick={() => setSelectedVehicle("car")}
            title="Four Wheeler"
          >
            <FaCarSide size={48} className={selectedVehicle === "car" ? "text-white" : "text-brandRed"} />
          </div>
          <div
            className={`text-center p-2 border-2 rounded-circle ${selectedVehicle === "pickup" ? "bg-brandRed border-3 border-brandRed" : "border-brandRed"}`}
            style={{ cursor: "pointer" }}
            onClick={() => setSelectedVehicle("pickup")}
            title="Pickup Truck"
          >
            <FaTruckPickup size={48} className={selectedVehicle === "pickup" ? "text-white" : "text-brandRed"} />
          </div>
        </div>

        <Formik
          initialValues={{
            cc: "",
            seatingCapacity: "",
            fuelType: "",
            grossWeight: "",
            exShowroomPrice: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="form-label">
                    Commercial Vehicle <span className="text-danger">*</span>
                  </label>
                  <Field as="select" name="commercialVehicle" className="form-select custom-shadow px-3 py-2">
                    <option value="">Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Field>
                  <ErrorMessage name="commercialVehicle" component="div" className="text-brandRed" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Make <span className="text-danger">*</span>
                  </label>
                  <Field as="select" name="make" className="form-select custom-shadow  px-3 py-2">
                    <option value="">Select Make</option>
                    <option value="Tata">Tata</option>
                    <option value="Hyundai">Hyundai</option>
                  </Field>
                  <ErrorMessage name="make" component="div" className="text-brandRed" />

                </div>
                <div className="col-md-4">
                  <label className="form-label">Model <span className="text-danger">*</span>
                  </label>
                  <Field as="select" name="model" className="form-select custom-shadow  px-3 py-2">
                    <option value="">Select Model</option>
                    <option value="Ace">Ace</option>
                    <option value="i20">i20</option>
                  </Field>
                  <ErrorMessage name="model" component="div" className="text-brandRed" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Variant</label>
                  <Field type="text" name="variant" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">CC</label>
                  <Field type="text" name="cc" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Seating Capacity <span className="text-danger">*</span>
                  </label>
                  <Field type="text" name="seatingCapacity" className="form-control custom-shadow" />
                  <ErrorMessage name="seatingCapacity" component="div" className="text-brandRed" />

                </div>

                <div className="col-md-4">
                  <label className="form-label">Fuel Type <span className="text-danger">*</span>
                  </label>
                  <Field as="select" name="fuelType" className="form-select custom-shadow  px-3 py-2">
                    <option value="">Select Fuel Type</option>
                    <option value="Petrol">Petrol</option>
                    <option value="Diesel">Diesel</option>
                  </Field>
                  <ErrorMessage name="fuelType" component="div" className="text-brandRed" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Gross Weight</label>
                  <Field type="text" name="grossWeight" className="form-control custom-shadow" />
                </div>

                <div className="col-md-4">
                  <label className="form-label">Ex Showroom Price</label>
                  <Field type="text" name="exShowroomPrice" className="form-control custom-shadow" />
                </div>
              </div>

              <div className="d-flex justify-content-start gap-3 mt-5 justify-content-center">
                <button type="submit" className="saveButton d-flex" disabled={isSubmitting}>
                  <span className="m-auto p-1"><LuSave /></span>{isSubmitting ? "Saving..." : "Save"}
                </button>
                <div className="flex gap-3">
                  <button type="button" className="d-flex backButton d-flex" onClick={() => window.history.back()}>
                    <span className="m-auto p-1"><GiCrossedBones /></span>Cancel
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddVehicleMaster;
